import { getApiClientVigo } from "./ApiClientVigo.js";

/**
 * Prüft eine RD-Nummer beim Backend und gibt die RD-Daten zurück
 * @param {number|string} rdnummer - Die zu prüfende RD-Nummer (muss 4-stellig sein)
 * @returns {Promise<{success: boolean, aokName?: string, rdnummer?: number}>} 
 *          Erfolg: { success: true, aokName: 'Name', rdnummer: 1234 }
 *          Fehler: { success: false }
 */
export async function checkRdNummer(rdnummer) {
    // Validierung: Nur 4-stellige Integer-Zahlen erlaubt (1000-9999)
    const rdnummerInt = parseInt(rdnummer, 10);
    
    if (isNaN(rdnummerInt) || rdnummerInt < 1000 || rdnummerInt > 9999) {
        return { success: false }; // Ungültige Eingabe
    }
    
    try {
        const client = getApiClientVigo();
        const url = `/v2/regionaldirektion/regionaldirektion?rdnummer=${rdnummerInt}`;
        
        const response = await client.get(url, {
            validateStatus: (status) => status === 200 || status === 400
        });
        
        // Erfolgreich gefunden: Status 200 UND returncode 0
        if (response.status === 200 && response.data.returncode === 0) {
            // API-Struktur: response.data.regionaldirektionen[0].name
            const aokName = response.data.regionaldirektionen?.[0]?.name || '';
            
            return {
                success: true,
                aokName: aokName,
                rdnummer: rdnummerInt
            };
        }
        
        // Nicht gefunden oder ungültig
        return { success: false };
    } catch (error) {
        console.error('Fehler beim Prüfen der RD-Nummer:', error);
        return { success: false };
    }
}